module.exports = __webpack_public_path__ + "media/images/icons/outlined/node-collapse-63463abb39bcf9d9c969f33e04b6c989.svg";